import { create } from 'zustand'
import userService from '../services/userService'

const useUserStore = create((set) => ({
    profile: {
        id: null,
        email: '',
        role: '',
        link_offer_steam: '',
        phone: '',
        bank_name: '',
        bank_account_name: '',
        bank_account_num: '',
        created_at: '',
        updated_at: '',
    },
    loading: false,
    error: null,

    fetchProfile: async () => {
        set({ loading: true, error: null })
        try {
            const res = await userService.getProfile()
            localStorage.setItem('role', res.data.role)
            localStorage.setItem('user_id', res.data.id)
            localStorage.setItem('email', res.data.email)
            set({ profile: res.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    updateProfile: async (data) => {
        set({ loading: true, error: null })
        try {
            const res = await userService.updateProfile(data)
            set({ profile: { ...res.data }, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },
}))

export default useUserStore
